import { CSSProperties } from "react"
import { User } from "~/types/api/UserTypes"
import { Message } from "~/components/UserName/UserName"
import ProgressTypes from "~/enums/ProgressTypes"

export type exportType = (row: { value: string }) => { id: string }

export interface ProgressTypeDetail {
  title: ProgressTypes
  messageId: string
}

export const progressTypes: Record<string, ProgressTypeDetail> = {
  output: { title: ProgressTypes.OUTPUT, messageId: "term.output" },
  reject: { title: ProgressTypes.REJECT, messageId: "term.reject" },
  time: { title: ProgressTypes.TIME, messageId: "term.time" },
  setup: { title: ProgressTypes.SETUP, messageId: "term.setup" },
  trouble: { title: ProgressTypes.TROUBLE, messageId: "term.trouble" },
}

export interface Row<T> {
  index: number
  original: T
  values: T
}

export interface Column {
  id: string
  translationId?: string
  accessor:
    | string
    | ((row: Record<string, unknown>) => boolean)
    | ((row: Record<string, unknown>) => number)
    | ((row: Record<string, unknown>) => string)
    | ((row: Record<string, unknown>) => JSX.Element)
    | ((row: { splitted: boolean; isSplit: boolean }) => { splitted: boolean; isSplit: boolean })
  Header?: JSX.Element | string
  Cell?: (value: unknown, ...props: Record<string, unknown>[]) => JSX.Element | string
  filter?: (rows: Record<string, unknown>, id: number, filterValue: unknown) => unknown
  Filter?: ((props: unknown) => JSX.Element) | JSX.Element
  filterable?: boolean
  width?: number
  style?: CSSProperties
  summary?: boolean
  disableFilters?: boolean
  disableSortBy?: boolean
  showTooltip?: boolean
  debounce?: boolean
  sortType?: (rowA: Row, rowB: Row, columnId: string, asc: boolean) => number
  export?:
    | unknown
    | (({ value }: { value: User }, formatMessage: (arg0: Message) => string) => string)
    | ((value: string) => { id: string })
    | exportType
}

export interface SortType {
  id: string
  desc: boolean
}
